import script from "./TokenRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenRow.vue?vue&type=script&setup=true&lang=js"

import "./TokenRow.vue?vue&type=style&index=0&id=24ed97ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ed97ee"]])

export default __exports__